/**
 * 작성자 : 박승호
 * 날짜 : 2024.11.25
 * 기능 : 멀티셀렉트 컴포넌트
 */

import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import styled from 'styled-components';

interface Option {
  readonly label: string;
  readonly value: string;
}

const MultiSelectStyle = styled.div`
  width: 100%;
  min-width: 12rem;
  position: relative;

  .select__input {
    color: var(--text-primary) !important;
  }

  .basic-multi-select {
    gap: inherit !important;
  }
  .select__single-value {
    color: var(--text-primary);
  }
  .basic-single > :nth-child(3) {
    padding: 0;
    margin: 0;
    background-color: var(--tonal);
    border-radius: 5px;
    min-height: 2.5rem;
    max-height: 10rem;
    > div:first-child {
      /* width: 2rem;
      text-align: center; */
    }
    > div {
      padding: 0;
      margin: 0;
      gap: 0.2rem;
      > div {
        margin: 0;
        padding: 0 0.25rem;
        font-size: 0.875rem;
        svg {
          color: var(--text-tertiary);
        }
      }
    }
    span {
      background-color: var(--outline);
    }
  }
  .select__menu {
    position: absolute !important;
    z-index: 99999;
    width: 100% !important;
    min-width: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    .select__menu-list {
      background-color: var(--tonal);
      .select__option {
        color: var(--text-primary);
        cursor: pointer;
        &:hover,
        &.select__option--is-focused {
          background-color: var(--tonal-deep);
        }
        &.select__option--is-selected {
          background-color: var(--selected-primary);
        }
      }
    }
  }
  .select__control {
    width: 100%;
  }
`;

interface Props {
  options: Option[];
  value: Option[];
  setVal: Dispatch<SetStateAction<Option[]>>;
  placeholder?: string;
  maxSelectCount?: number;
  isDisabled?: boolean;
  optionMaxHeight?: number; // 옵션 창 최대 높이값
  setIsUpdated?: (isUpdated: boolean) => void;
}

const MultiSelect = ({ options, value, setVal, placeholder = '', maxSelectCount, isDisabled = false, optionMaxHeight = 300, setIsUpdated }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleChange = (val: Option[]) => {
    if (maxSelectCount !== undefined && val.length > maxSelectCount) {
      toast.warning(t(`최대 선택 개수를 초과하였습니다. (${maxSelectCount} 개)`));
    } else {
      setVal([...(val || [])]);
    }
    setIsUpdated?.(true);
  };

  return (
    <MultiSelectStyle>
      <Select
        className='basic-multi-select'
        classNamePrefix='select'
        isMulti
        isClearable
        isSearchable
        name='users'
        options={options}
        value={value}
        onChange={(val) => handleChange(val as Option[])}
        placeholder={t(`${placeholder} 선택`)}
        isDisabled={isDisabled}
        menuShouldScrollIntoView
        maxMenuHeight={optionMaxHeight}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 99999,
          }),
        }}
      />
    </MultiSelectStyle>
  );
};

export default MultiSelect;
